"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Modal_1 = require("../Modal");
var UploadFileItem_1 = __importDefault(require("../UploadFileItem"));
var MainDialog_1 = __importDefault(require("./MainDialog"));
var styles_1 = require("./styles");
var ImportFileModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onFiles = _a.onFiles, importFiles = _a.importFiles, title = _a.title, supportText = _a.supportText, subActionText = _a.subActionText, clickText = _a.clickText, dragAndDropText = _a.dragAndDropText, inputAccept = _a.inputAccept, isMultiple = _a.isMultiple;
    if (!isOpen) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(Modal_1.Modal, __assign({ onClose: onClose, withoutInner: true }, { children: [(0, jsx_runtime_1.jsx)(MainDialog_1.default, { title: title, supportText: supportText, subActionText: subActionText, clickText: clickText, dragAndDropText: dragAndDropText, onFiles: onFiles, inputAccept: inputAccept, isMultiple: isMultiple, onClose: onClose }), importFiles.map(function (file) { return ((0, jsx_runtime_1.jsx)(styles_1.BorderRadiusContainer, { children: (0, jsx_runtime_1.jsx)(UploadFileItem_1.default, __assign({}, file)) }, file.id)); })] })));
};
exports.default = ImportFileModal;
